
const getters = {
    openedTabList: state => {
        return state.table.openedTabList
        // if(state.app.language=='zh'){
        //     let openedTabList = state.table.openedTabList
        //     openedTabList = state.table.openedTabList.map((item,index)=>{
        //             return {
        //                 componentName: item.componentName,
        //                 name: item.name
        //           }
                  
        //     })
        //     console.log("0000",openedTabList)
        //     return openedTabList
        // }else{
        //     let openedTabList = state.table.openedTabList
        //     openedTabList = state.table.openedTabList.map((item,index)=>{
        //             return {
        //                 componentName: item.componentName,
        //                 name: item.name+'我是英文'
        //           }
                  
        //     })
        //     console.log("1111",openedTabList)
        //     return openedTabList
        // }
        
        
    },
    activeTab: state => state.table.activeTab,
    watchOpenedTabList: state => state.table.watchOpenedTabList,
    baseURL: state => {
        console.log(state,111010)
        return state.utils.baseURL
    },
    filePath: state => state.utils.filePath,
    contractCon: state => state.utils.contractCon,
    contractUpgrade: state => state.utils.contractUpgrade,
    roleId: state => state.utils.roleId,
    contract_list: state => state.utils.contract_list,
    upgrade_contract: state => state.utils.upgrade_contract,
    deploy_contract: state => state.utils.deploy_contract,
}
export default getters
